/**
 * Lightweight environment-aware logger.
 *
 * Security-by-design: diagnostic logs (`debug`/`warn`) are emitted only in
 * development. In production builds they are no-ops, so we never leak internal
 * state, error details, or request metadata to the browser console of end
 * users. `error` is always emitted so genuine failures remain observable
 * (and can be wired to an error-reporting service later).
 */
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
};

export default logger;
